export class AdminGrowthInvestmentMonthlyPoint {
  label = ""

  investmentAmount = 0

  subscriptionRevenueAmount = 0

  associatedRevenueAmount = 0

  profitOrLossAmount = 0

  constructor(data: Partial<AdminGrowthInvestmentMonthlyPoint> = {}) {
    Object.assign(this, data)
  }
}
